export function WeeklyFeaturedSpotlight({ listing }) {
  if (!listing) return null;
  return (
    <div className="bg-navy py-12 px-4" data-testid="weekly-featured">
      <div className="max-w-4xl mx-auto text-center">
        <div className="text-[#F45B63] text-xs font-mono font-bold uppercase mb-3">Featured This Week</div>
        <h2 className="font-heading text-3xl sm:text-4xl text-white font-bold mb-3">{listing.name}</h2>
        <p className="font-body text-white/80 text-sm mb-2">{listing.zone} &middot; {listing.category} &middot; Grade {listing.healthGrade}</p>
        {listing.clinicalDescription && <p className="font-body text-white/60 text-sm max-w-2xl mx-auto mb-6">{listing.clinicalDescription}</p>}
        <a href={`/listing/${listing.id}`} className="inline-flex items-center gap-2 bg-brand-red hover:bg-red-800 text-white px-6 py-3 font-mono text-[10px] uppercase font-semibold transition-colors" data-testid="weekly-featured-view-listing">
          View Listing
        </a>
      </div>
    </div>
  );
}
